export const RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR =
	'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';
